import { ContentSaveSettingsIcon } from './ContentSaveSettingsIcon';

/**
 * author: Simran
 * id 67E755F6-209A-41EF-98C5-423739A3AC10
 * name content-save-settings
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-settings.svg
 * tags
 * - Settings 
 */
export const FloppyDiscSettingsIcon = ContentSaveSettingsIcon;
export default FloppyDiscSettingsIcon